import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { QueryParamsModel, QueryResultsModel } from '../../_base/crud';
import { KgCheckReport } from '../_models/kg_check_report.model';

@Injectable()
export class KgCheckReportService {
  constructor(private http: HttpClient) {}

  getAllKgCheckReports(): Observable<KgCheckReport[]> {
    return this.http.get<KgCheckReport[]>('api/reports/kg_check_reports/');
  }

  findKgCheckReports(
    queryParams: QueryParamsModel
  ): Observable<QueryResultsModel> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    return this.http.post<QueryResultsModel>(
      'api/reports/kg_check_reports/find/',
      queryParams,
      { headers: httpHeaders }
    );
  }

  persistent_nf(): Observable<Array<string>> {
    const httpHeaders = new HttpHeaders();
    httpHeaders.set('Content-Type', 'application/json');
    return this.http.get<Array<string>>(
      'api/reports/kg_check_reports/persistent_nf/',
      { headers: httpHeaders }
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private handleError<T>(operation = 'operation', result?: any) {
    return (error: any): Observable<any> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result);
    };
  }
}
